// src/components/TokenCard.js
// import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import axios from 'axios';
import { format } from 'date-fns';
import { ja } from 'date-fns/locale';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

const TokenCard = ({ token }) => {
  // const [tokenImage, setTokenImage] = useState(null);

  // // トークン画像を取得
  // useEffect(() => {
  //   const fetchTokenImage = async () => {
  //     try {
  //       // トークンのアドレス - grantTokenを使用
  //       const tokenAddress = token.grantToken;
  //       if (!tokenAddress) return;

  //       // APIのURLを画像URLとして直接使用
  //       const imageUrl = `${process.env.REACT_APP_API_URL}/api/tokens/${tokenAddress}/image`;
  //       setTokenImage(`${imageUrl}`);

  //       // // バックエンドAPIからキャッシュ済みの画像を取得
  //       // const response = await axios.get(
  //       //   `${process.env.REACT_APP_API_URL}/api/tokens/${tokenAddress}/image`
  //       // );

  //       // if (response.data.imageUrl) {
  //       //   setTokenImage(`${process.env.REACT_APP_API_URL}${response.data.imageUrl}`);
  //       // } else if (token.img) {
  //       //   // APIから画像が取得できなければtoken.imgを使用
  //       //   setTokenImage(`${process.env.REACT_APP_API_URL}${token.img}`);
  //       // }
  //     } catch (error) {
  //       // 画像取得エラー時にtoken.imgを使用
  //       if (token.img) {
  //         setTokenImage(`${token.img}`);
  //       }
  //       console.log('Token image not found:', error);
  //     }
  //   };

  //   fetchTokenImage();
  // }, [token]);

  // アドレスを短縮
  const shortenAddress = address => {
    if (!address) return '';
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };

  // ブロックエクスプローラーのリンクを生成 - grantTokenを使用
  const getExplorerLink = address => {
    return `${process.env.REACT_APP_BLOCK_EXPLORER_URL}/address/${address}`;
  };

  // // トークンアイコンの背景色を生成（アドレスをもとにしたランダム色）
  // const getTokenColor = () => {
  //   // アドレスの取得（grantTokenを使用）
  //   const tokenAddress = token.grantToken;
  //   if (!tokenAddress) return 'bg-blue-100 dark:bg-blue-800';

  //   // アドレスの末尾6文字を取得してハッシュ化
  //   const hash = tokenAddress.substring(tokenAddress.length - 6);
  //   const hue = parseInt(hash, 16) % 360;

  //   // 明るめのパステルカラーを返す
  //   return `hsl(${hue}, 70%, 85%)`;
  // };

  // // トークンシンボルから最初の2文字を取得
  // const getTokenInitials = () => {
  //   if (!token || !token.symbol) return '??';
  //   return token.symbol.substring(0, 2).toUpperCase();
  // };

  // トークン詳細ページへのリンクアドレスを取得 - grantTokenを使用
  const getTokenDetailLink = () => {
    // grantTokenを使用
    const tokenAddress = token.grantToken;
    if (!tokenAddress) return '/tokens'; // アドレスがない場合はトークン一覧に戻る
    return `/tokens/${tokenAddress}`;
  };

  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden transition transform hover:-translate-y-1 hover:shadow-md ${
        token.isBanned ? 'opacity-60' : ''
      }`}
    >
      <Link to={getTokenDetailLink()} className="block h-full">
        <div className="p-5">
          <div className="flex items-center mb-4">
            {/* {tokenImage ? ( */}
            <img
              src={token.img}
              alt={token.name}
              className="w-12 h-12 rounded-full object-cover mr-3"
              onError={e => {
                // 画像が読み込めない場合はフォールバック
                e.target.style.display = 'none';
                e.target.nextElementSibling.style.display = 'flex';
              }}
            />
            {/* ) : null} */}

            {/* フォールバックアイコン (初期状態では非表示) */}
            {/* <div
              className={`flex items-center justify-center w-12 h-12 rounded-full ${getTokenColor()} text-gray-700 dark:text-gray-200 font-bold mr-3 ${
                tokenImage ? 'hidden' : 'flex'
              }`}
            >
              {getTokenInitials()}
            </div> */}

            <div>
              <div className="flex items-center">
                <h3 className="font-bold text-lg text-gray-900 dark:text-gray-100">{token.name}</h3>
                {token.isBanned && (
                  <span className="ml-2 text-xs bg-red-100 dark:bg-red-800 text-red-800 dark:text-red-200 px-2 py-0.5 rounded-full">
                    BAN
                  </span>
                )}
                {token.isPromode && (
                  <span className="ml-2 text-xs bg-purple-100 dark:bg-purple-800 text-purple-800 dark:text-purple-200 px-2 py-0.5 rounded-full font-semibold">
                    PRO
                  </span>
                )}
              </div>
              <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                <span className="mr-1">{token.symbol}</span>
                <a
                  href={getExplorerLink(token.grantToken)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 ml-1"
                  onClick={e => e.stopPropagation()}
                  title="ブロックエクスプローラーで表示"
                >
                  <ArrowTopRightOnSquareIcon className="h-4 w-4" />
                </a>

                {token.yukichiurl && (
                  <a
                    href={token.yukichiurl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 ml-1"
                    onClick={e => e.stopPropagation()}
                    title="yukichiで表示"
                  >
                    <ArrowTopRightOnSquareIcon className="h-4 w-4" />
                  </a>
                )}
              </div>
            </div>
          </div>

          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500 dark:text-gray-400">発行者:</span>
              <Link
                to={`/user/${token.issuerAddress}`}
                className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
                onClick={e => e.stopPropagation()}
              >
                {shortenAddress(token.issuerAddress)}
              </Link>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-500 dark:text-gray-400">上場日:</span>
              <span className="text-gray-900 dark:text-gray-100">
                {token.launchedAt
                  ? format(new Date(token.launchedAt), 'yyyy/MM/dd', { locale: ja })
                  : format(new Date(token.createdAt), 'yyyy/MM/dd', { locale: ja })}
              </span>
            </div>

            {/* ペアタイプからトークンペアに用語を統一 */}
            {token.pairType && (
              <div className="flex justify-between">
                <span className="text-gray-500 dark:text-gray-400">トークンペア:</span>
                <span className="text-gray-900 dark:text-gray-100">{token.pairType}</span>
              </div>
            )}
          </div>
        </div>

        {/* フッター */}
        <div className="px-5 py-3 bg-gray-50 dark:bg-gray-700 text-sm text-gray-600 dark:text-gray-300 flex justify-between items-center">
          <span className="truncate max-w-[180px]" title={token.grantToken}>
            {shortenAddress(token.grantToken)}
          </span>

          <span className="text-blue-600 dark:text-blue-400 font-medium">詳細を見る →</span>
        </div>
      </Link>
    </div>
  );
};

export default TokenCard;
